import { Request } from '../../index'

export type SchoolSubsidyComplexesParams = {
  schoolId: string
}

export type SchoolSubsidyComplex = {
  id: number | string
  title: string
}

type ApiParams = {
  school_id: number
}

type ApiResult = SchoolSubsidyComplex[]

export const convertParams = ({
  schoolId,
}: SchoolSubsidyComplexesParams): [ApiParams, null] => [
  { school_id: Number(schoolId) },
  null,
]

export const convertResult = (apiData: ApiResult): SchoolSubsidyComplex[] => apiData || []

export const GET_SCHOOL_SUBSIDY_COMPLEXES: Request<
  SchoolSubsidyComplexesParams,
  SchoolSubsidyComplex[],
  void
> = ['reports/school_subsidy_complexes', 'get', ['data', 'complexes']]
